<template>
  <ModalTriage :visibleModalTriage="isModalTriageVisible" @close="closeModalTriage"
               :protocolUpdatePopup="Report?.protocol_update_info"
               :enableButton="false"></ModalTriage>
  <ModalLoadingSignature :visibleModalLoadingSignature="isModalLoadingSignature" :typeSteps="typeSteps"
                         @close="closeModalLoadingSignature"></ModalLoadingSignature>
  <div class="col-12">
    <div class="mt-5 mb-5">
      <div class="row">
        <div class="col-2">
          <button class="button-back mx-3" @click="back()">
            <img src="../assets/back-button.png" alt="Button Image">
          </button>
        </div>
        <div class="col-8">
          <div>
            <h2 class="texto-regular-bold text-center" style="color: #777777">Informações do caso</h2>
          </div>

          <div v-if="isLoading === true">
            <div class="conteiner mt-5 mb-5">
              <div class="row mt-5">
                <div class="row mt-4">
                  <div class="col-2"></div>
                  <div class="col-8">
                    <div class="centered-container">
                      <div class="loading"></div>
                    </div>
                    <p class="text-font-regular" style="margin-top: 10px; text-align: center">
                      Carregando...
                    </p>
                  </div>
                  <div class="col-2"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="Report !== null">
              <div class="container-info mt-4">
                <h5 class="texto-regular-bold" style="color: #777777">Nº de protocolo: </h5>
                <h5 class="texto-regular-bold" style="color: #777777">{{ Report.id }}</h5>
              </div>
              <div class="container-info mt-4">
                <h5 class="texto-regular-bold" style="color: #777777">Paciente: </h5>
                <h5 class="texto-regular-bold" style="color: #777777">{{
                    Report.protocol_update_info.protocol_info.patient_info.name
                  }}</h5>
              </div>
              <h5 class="texto-regular-bold mt-4" style="color: #777777">Revise as informações abaixo:</h5>


              <div class="container-historical mt-4">
                <div v-for="field in ReportFields" :key="field.id">
                  <div v-if="Report[field.name] != null">
                    <div v-if="field.name === 'sedated'">
                      <div v-if="Report[field.name] > 0">
                        <div class="mt-4">
                          <p class="texto-regular">{{ field.description }}<strong class="texto-regular-bold"
                                                                                  style="word-wrap: break-word; text-align: justify;">{{
                              formatRamsay(Report[field.name])
                            }}</strong>
                          </p>
                        </div>
                      </div>
                      <div v-else>
                        <div class="mt-4">
                          <p class="texto-regular">{{ field.description }}<strong class="texto-regular-bold"
                                                                                  style="word-wrap: break-word; text-align: justify;">Não</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="field.name === 'cid_subcategory'">
                      <div class="mt-4">
                        <p class="texto-regular">{{ field.description }} <strong class="texto-regular-bold"
                                                                                 style="word-wrap: break-word; text-align: justify;">{{
                            Report[field.name].description
                          }}</strong></p>
                      </div>
                    </div>
                    <div v-else-if="['transference', 'protocol_avc', 'thrombolysis', 'had_teleconsultation', 'patient_present', 'catheterization'].includes(field.name)">
                      <div class="mt-4">
                        <p class="texto-regular">{{ field.description }}<strong class="texto-regular-bold"
                                                                                 style="word-wrap: break-word; text-align: justify;">{{
                            Report[field.name] === 1 ? "Sim" :
                                "Não"
                          }}</strong>
                        </p>
                      </div>
                    </div>
                    <div v-else-if="field.name === 'clinical_documents'">
                      <div class="mt-4" v-for="(clinicalDocument, clinicalDocumentIndex) in Report[field.name]"
                           :key="clinicalDocumentIndex">
                        <p>{{ clinicalDocument.description }}: <strong class="fw-bold"
                                                                       style="word-wrap: break-word; text-align: justify;">{{
                            clinicalDocument.value
                          }}</strong></p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="mt-4">
                        <p class="texto-regular">{{ field.description }} <strong class="texto-regular-bold"
                                                                                 style="word-wrap: break-word; text-align: justify;">{{
                            Report[field.name]
                          }}</strong></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="verifyOwnerReport()">
                <div class="d-grid gap-2 offset-4 col-4 pb-2" v-if="findForStep4(Report.statuses) === false">
                  <button class="btn btn-primary" @click="showModalReportFinished()"
                          data-bs-toggle="modal" data-bs-target="#loadingSignatureModal"><i class="bi bi-pen"></i>
                    Assinar Laudo
                  </button>
                </div>
              </div>
              <div class="d-grid gap-2 offset-4 col-4">
                <button class="btn btn-outline-success" @click="downloadReportHistory()"><i class="bi bi-download"></i>
                  Baixar Laudo
                </button>
                <button v-for="clinicalDocument in Report.clinical_documents" class="btn btn-outline-success"
                        @click="downloadClinicalDocument(clinicalDocument.file_id)" v-bind:key="clinicalDocument.id"><i
                    class="bi bi-download"></i>
                  Baixar {{ clinicalDocument.description }}
                </button>

                <button class="btn btn-primary" @click="showModalTriage()"
                        data-bs-toggle="modal" data-bs-target="#triageModal">
                  <i class="bi bi-card-checklist"></i> Informações da Triagem
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalTriage from "../components/ModalTriage.vue";
import ModalLoadingSignature from "../components/ModalLoadingSignature.vue"
import {mapGetters, mapActions} from "vuex";
import axios from "axios";

export default {
  name: `Review`,
  components: {
    ModalTriage,
    ModalLoadingSignature
  },
  computed: {
    ...mapGetters({
      Report: "StateReport",
      User: "StateUser",
      UrlReport: "StateUrlReport",
      ReportFields: "StateReportFields"
    }),
  },
  data() {
    return {
      isLoading: true,
      protocolInfo: Object,
      isModalTriageVisible: false,
      isModalLoadingSignature: false,
      typeSteps: "",
      reportId: null,
    };
  },
  async created() {
    this.reportValue = this.Report
    if (!this.isAuthenticated()) {
      this.$router.push("/login");
    }
    if (this.Report === null) {
      this.reportId = JSON.parse(localStorage.getItem('reportId'));
      if (this.reportId != null) {
        await this.GetReportById(this.reportId);
        localStorage.removeItem('reportId');
        this.isLoading = false;
      } else {
        this.$router.push("/historical");
      }
    }
  },
  async mounted() {
    try {
      if (this.Report !== null) {
        await this.GetReportFields(this.Report.protocol_update_info.protocol_info.specialty_id);
        this.isLoading = false;
      }
    } catch {
      this.$toast.error('Ocorreu um erro, tente novamente.', {
        timeout: 3000,
        closeOnClick: true
      });
    }
  },
  methods: {
    ...mapActions(["GetReportFields"]),
    ...mapActions(["SetReport"]),
    ...mapGetters(["isAuthenticated"]),
    ...mapActions(["GetReport"]),
    ...mapActions(["GenerateReport"]),
    ...mapActions(["ResignReport"]),
    ...mapActions(["GetReportById"]),
    verifyOwnerReport() {
      if (this.User.specialist.id === this.Report.specialist_info.id) {
        return true;
      }
      return false;
    },
    back() {
      this.$router.back();
    },
    showModalTriage() {
      this.isModalTriageVisible = true;
    },
    closeModalTriage() {
      this.isModalTriageVisible = false;
    },
    async showModalReportFinished() {
      await this.ResignReport(this.Report)
      this.typeSteps = "historic"
      this.isModalLoadingSignature = true;
    },
    closeModalLoadingSignature() {
      this.isModalLoadingSignature = false;
    },
    async downloadReportHistory() {
      try {
        await this.GenerateReport(this.Report)
        const pdfUrl = this.UrlReport;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    async downloadClinicalDocument(fileId) {
      try {
        const pdfUrl = await this.GetFileUrl(fileId);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    findForStep4(statuses) {
      const status = statuses.find((status) => status.step === 4);
      if (status) {
        return status.status === "success";

      } else {
        return false;
      }
    },
    formatRamsay(number) {
      return "Ramsay " + number
    },
    async GetFileUrl(fileId) {
      let fileUrl = null;
      await axios.post('/pep/file/get_url',
          {
            file_id: fileId
          },
          {
            headers: {Authorization: `Bearer ${this.User.token}`}
          })
          .then(response => {
            fileUrl = response.data.data.url;
          });
      return fileUrl;
    },
  },
};
</script>

<style>
.button-back {
  background-color: #ffff;
  border: none;
}

.texto-regular-bold {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 5px;
}

.texto-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}

.container-info {
  display: flex;
}

.container-info {
  display: flex;
}

.texto-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}

.texto-regular-bold {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 5px;
}

.loading {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
